import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    ComponentsService,
    SIMULATION_GAME_CODE
} from 'src/app/components.service';
import { forkJoin, Subscription, take } from 'rxjs';
import { SideNavItem } from './side-navbar.type';

@Component({
    selector: 'app-side-navbar',
    templateUrl: './side-navbar.component.html',
    styleUrls: ['./side-navbar.component.css']
})
export class SideNavbarComponent implements OnInit, OnDestroy {
    @Input() opened: boolean;
    menuList: SideNavItem[] = [];
    subscription: Subscription | null = null;

    constructor(private service: ComponentsService) {}

    async ngOnInit() {
        this.subscription = this.service.clientChanged.subscribe(() => {
            this.init();
        });

        this.init();
    }

    init() {
        forkJoin([
            this.service.clientName(this.service.getClientUuid()),
            this.service.getAllGames()
        ])
            .pipe(take(1))
            .subscribe(([clientNameResponse, { data: games }]) => {
                const simGames = [];
                const clientGames = clientNameResponse?.clientGames || [];

                clientGames.forEach((clientGame) => {
                    const game = games.find(
                        (game) => game.gameCode === clientGame
                    );
                    const updatedGame = {
                        ...clientGame,
                        ...(game && { gameName: game.gameName })
                    };
                    if (game && game.gameType === 'virtual_sport') {
                        simGames.push(updatedGame);
                    }
                });

                const clientId = this.service.getClientUuid();
                const isSuperAdmin = !!this.service.getUsersPerm().superAdmin;
                this.menuList = [
                    {
                        text: 'Product management',
                        icon: 'home',
                        routerLink: '#',
                        children: [
                            simGames.length && {
                                text: 'Virtual Games',
                                icon: '',
                                routerLink: '#',
                                children: simGames.map(
                                    ({ gameName, gameCode, gameType }) => {
                                        return {
                                            id: 0,
                                            text: gameName,
                                            icon: '',
                                            routerLink: '#',
                                            children: [
                                                ...(isSuperAdmin
                                                    ? [
                                                          {
                                                              text: 'Settings',
                                                              icon: '',
                                                              routerLink: `product_man_settings/${gameCode}`,
                                                              queryParams: {
                                                                  clientId,
                                                                  gameType:
                                                                      gameType
                                                              }
                                                          }
                                                      ]
                                                    : []),
                                                {
                                                    text: 'Tickets Preview',
                                                    icon: '',
                                                    routerLink: `tickets/${SIMULATION_GAME_CODE}`,
                                                    queryParams: {
                                                        clientId,
                                                        gameType: gameType
                                                    }
                                                }
                                            ]
                                        };
                                    }
                                )
                            }
                        ]
                    },
                    {
                        text: 'User management',
                        icon: 'manage_accounts',
                        routerLink: '/home/user_man'
                    },
                    {
                        text: 'Currency management',
                        icon: 'manage_accounts',
                        routerLink: 'app-ccy-management'
                    },
                    {
                        text: 'Blocked Players',
                        icon: 'blocked',
                        routerLink: 'app-blocked-players'
                    },
                    {
                        text: 'Betstop Status',
                        icon: 'blocked',
                        routerLink: 'app-betstop-status'
                    },
                    // Boje po klijentu - ista dozvola kao ostala podesavanja klijenta
                    ...(isSuperAdmin
                        ? [
                              {
                                  text: 'Theme (boje)',
                                  icon: 'palette',
                                  routerLink: 'theme'
                              }
                          ]
                        : [])
                ];
            });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
